import { createElement, forwardRef } from 'react';
import { bleed } from '../patterns/bleed.js';
import { splitProps } from '../helpers.js';
import { styled } from './factory.js';

export const Bleed = /* @__PURE__ */ forwardRef(function Bleed(props, ref) {
  const [patternProps, restProps] = splitProps(props, bleed.propKeys)
  const styleProps = bleed.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})